import React from 'react';
import { translate } from 'react-i18next';

import SignedOutHeader from '../../components/signin/signedOutHeader';

const Start = ({ t }) => (
  <section>
    <SignedOutHeader />
    <div className="main-container">
      <h2 className="start-page">{t('start_read_qr')}</h2>
    </div>
  </section>
);

export default translate('common')(Start);
